"use client"

import { useContext, useEffect, useState } from "react"
// import { useCallback } from "react" // Not currently used
import { useParams } from "react-router-dom"
// import { useNavigate } from "react-router-dom" // Not currently used
import { Link } from "react-router-dom"
import ProductCard from "../components/ProductCard"
import addToCart from "../helpers/addToCart"
import Context from "../context"
import "./ProductDetails.css"
import { toast } from "react-hot-toast"
import summaryApi from "../common/index"
import Sidebar from "../components/sidebar"


// const sizes = ["XS", "S", "M", "L", "XL"] // Not currently used
const ProductDetails = () => {
  const [product, setProduct] = useState({
    productName: "",
    brandName: "",
    section: "",
    audience: "",
    generalCategory: "",
    generalSubcategory: "",
    essentialsCategory: "",
    productImages: [],
    description: [],
    materials: [],
    careInstructions: [],
    priceRs: 0,
    compareAtPriceRs: 0,
    itemNumber: "",
    manufacturer: { name: "", address: "" },
    sizes: [],
    packagingOptions: [],
  })
  const params = useParams()
  // const [loading, setLoading] = useState(true) // Not currently used
  // const [size, setSize] = useState("") // Not currently used
  const [activeImage, setActiveImage] = useState(null) // For thumbnail selection
  const [modalImage, setModalImage] = useState(null) // For full-size modal

  const [allProducts, setAllProducts] = useState([])
  const [loadingProducts, setLoadingProducts] = useState(true)

  const [wishlistedItems, setWishlistedItems] = useState(new Set())
  const [loadingWishlist, setLoadingWishlist] = useState(true)

  const [addingToCart, setAddingToCart] = useState(false)
  const { fetchUserAddToCart, fetchUserWishlistCount, openCartSidebar, isCartOpen, closeCartSidebar } =
    useContext(Context)

  // Wishlist toggle
const handleWishlistToggle = async (productId) => {
  if (!productId) return
  const isWishlisted = wishlistedItems.has(productId)

  try {
    if (isWishlisted) {
      const res = await fetch(summaryApi.removeWishlistProduct.url, {
        method: summaryApi.removeWishlistProduct.method,
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ productId }),
      })
      const data = await res.json()
      if (data.success) {
        setWishlistedItems((prev) => {
          const newSet = new Set(prev)
          newSet.delete(productId)
          return newSet
        })
        toast.success("Product removed from wishlist!")
        await fetchUserWishlistCount?.()
      } else {
        toast.error("Failed to remove from wishlist.")
      }
    } else {
      const res = await fetch(summaryApi.addToWishlist.url, {
        method: summaryApi.addToWishlist.method,
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ productId }),
      })
      const data = await res.json()
      if (data.success) {
        setWishlistedItems((prev) => new Set(prev).add(productId))
        toast.success("Product added to wishlist!")
        await fetchUserWishlistCount?.()
      } else {
        toast.error("Failed to add to wishlist.")
      }
    }
  } catch (err) {
    toast.error("Could not update wishlist.")
  }
}

  const fetchWishlist = async () => {
  try {
    const res = await fetch(summaryApi.getWishlistProducts.url, {
      method: summaryApi.getWishlistProducts.method,
      credentials: "include",
      headers: { "Content-Type": "application/json" },
    })
    const data = await res.json()
    if (data.success) {
      const wishlistIds = new Set(data.data.map((item) => item.productId))
      setWishlistedItems(wishlistIds)
    } else {
      toast.error("Failed to load wishlist.")
    }
  } catch (err) {
    toast.error("Failed to load wishlist.")
  } finally {
    setLoadingWishlist(false)
  }
}

  const fetchAllProducts = async () => {
    try {
      setLoadingProducts(true)
      const res = await fetch(summaryApi.allProduct.url)
      const data = await res.json()
      setAllProducts(data?.data || [])
    } catch (err) {
      console.error("Failed to fetch products:", err)
    } finally {
      setLoadingProducts(false)
    }
  }

  // const [zoomImageCoordinate, setZoomImageCoordinate] = useState({
  //   x: 0,
  //   y: 0,
  // }) // Not currently used
  // const [zoomImage, setZoomImage] = useState(false) // Not currently used

  // const navigate = useNavigate() // Not currently used

 const fetchProductDetails = async () => {
  try {
    // setLoading(true) // Not currently used

    const response = await fetch(summaryApi.productDetails.url, {
      method: summaryApi.productDetails.method,
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({
        productId: params?.id,
      }),
    })

    const dataResponse = await response.json()
    console.log("API response:", dataResponse)

    const productData = dataResponse?.data
    // setLoading(false) // Not currently used

    if (productData) {
      setProduct(productData)
      // Don't set activeImage automatically - only when user clicks
    }
  } catch (err) {
    // setLoading(false) // Not currently used
    console.error("Error fetching product details:", err)
  }
}


  useEffect(() => {
    fetchProductDetails()
    fetchWishlist()
    fetchAllProducts()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params])

  // const handleMouseEnterProduct = (imageURL) => {
  //   setActiveImage(imageURL)
  // } // Not currently used

  // const handleZoomImage = useCallback(
  //   (e) => {
  //     setZoomImage(true)
  //     const { left, top, width, height } = e.target.getBoundingClientRect()

  //     const x = (e.clientX - left) / width
  //     const y = (e.clientY - top) / height

  //     setZoomImageCoordinate({
  //       x,
  //       y,
  //     })
  //   },
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  //   [],
  // ) // Not currently used

  // const handleLeaveImageZoom = () => {
  //   setZoomImage(false)
  // } // Not currently used

const handleAddToCart = async (e, id) => {
  setAddingToCart(true);

  try {
    const result = await addToCart(e, id); // no size parameter

    if (result.success) {
      await fetchUserAddToCart();
      openCartSidebar();
      toast.success("Product added to cart!");
    } else {
      toast.error(result.message || "Failed to add product to cart");
    }
  } catch (error) {
    toast.error("Failed to add product to cart");
  } finally {
    setAddingToCart(false);
  }
};



  return (
    <>
      <main className="mx-auto w-full px-4 md:px-6 lg:px-8 text-gray-900">
        <nav className="py-3 text-xs text-gray-500">
          <ol className="flex flex-wrap gap-1">
            <li>
              <Link to="/" className="hover:underline">
                Home
              </Link>
            </li>
            <li>/</li>
            <li>
              <Link to="/products" className="hover:underline">
                Products
              </Link>
            </li>
            <li>/</li>
            <li className="font-medium text-gray-900">{product?.productName}</li>
          </ol>
        </nav>

  <section className="grid gap-6 lg:gap-8 lg:grid-cols-2 py-4 lg:py-6">
  
     {/* Image Gallery Section */}
     <div className="space-y-3">
        {/* Main Image */}
        <div className="relative aspect-square w-full bg-gray-50 rounded-lg overflow-hidden border border-gray-200">
          <img
            src={activeImage || product.productImages?.[0]?.url || "/placeholder.svg"}
            alt={product.productName || "Product Image"}
            className="w-full h-full object-contain p-4 cursor-pointer"
            onClick={() => setModalImage(activeImage || product.productImages?.[0]?.url || "")}
          />
        </div>

        {/* Thumbnail Gallery */}
        {product.productImages && product.productImages.length > 1 && (
          <div className="grid grid-cols-4 sm:grid-cols-5 gap-2">
            {product.productImages.map((img, idx) => {
              const isActive = activeImage === img.url || (!activeImage && idx === 0)
              return (
                <button
                  key={idx}
                  onClick={() => {
                    // Update main image display
                    setActiveImage(img.url)
                  }}
                  className={`relative aspect-square rounded-md overflow-hidden border-2 transition-all ${
                    isActive
                      ? "border-[#8B4513]"
                      : "border-gray-200 hover:border-gray-300"
                  }`}
                >
                  <img
                    src={img.url || "/placeholder.svg"}
                    alt={`Thumbnail ${idx + 1}`}
                    className="w-full h-full object-cover"
                  />
                </button>
              )
            })}
          </div>
        )}






        {/* Full image modal - Only show when user clicks main image */}
        {modalImage && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70"
            onClick={() => setModalImage(null)}
          >
            <div
              className="relative"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="absolute top-2 right-2 text-white text-2xl font-bold z-50 hover:text-gray-300"
                onClick={() => setModalImage(null)}
              >
                &times;
              </button>
              <img
                src={modalImage}
                alt="Full Product"
                className="max-w-[90vw] max-h-[90vh] object-contain shadow-lg"
              />
            </div>
          </div>
        )}
      </div>

  {/* Product Info Section */}
  <div className="space-y-5">
    {/* Brand & Title */}
    {product.brandName && (
      <div className="text-xs font-medium text-[#8B4513] uppercase tracking-wide">
        {product.brandName}
      </div>
    )}
    
    <div>
      <h1 className="text-2xl md:text-3xl font-bold text-gray-900 leading-tight mb-3">
        {product.productName || "Product Name"}
      </h1>
      
      {/* Price Section */}
      <div className="flex items-baseline gap-3 mb-4">
        <span className="text-2xl md:text-3xl font-bold text-[#8B4513]">
          £ {product.priceRs?.toLocaleString(undefined, { minimumFractionDigits: 2 }) || "0.00"}
        </span>
        {product.compareAtPriceRs && product.compareAtPriceRs > product.priceRs && (
          <>
            <span className="text-lg text-gray-400 line-through">
              £ {product.compareAtPriceRs.toLocaleString(undefined, { minimumFractionDigits: 2 })}
            </span>
            <span className="px-2 py-1 bg-red-100 text-red-600 text-xs font-semibold rounded">
              {Math.round(((product.compareAtPriceRs - product.priceRs) / product.compareAtPriceRs) * 100)}% OFF
            </span>
          </>
        )}
      </div>
    </div>

    {/* Weight Display */}
    {product.packagingOptions && product.packagingOptions.length > 0 && (
      <div className="py-3">
        <h3 className="text-sm font-medium text-gray-700 mb-2">Available Weights:</h3>
        <div className="flex flex-wrap gap-2">
          {product.packagingOptions.map((option, idx) => (
            <span
              key={idx}
              className="inline-flex items-center px-3 py-1.5 rounded-md text-sm font-medium bg-[#8B4513] text-white hover:bg-[#654321] transition-colors"
            >
              {option.weight}
            </span>
          ))}
        </div>
      </div>
    )}

    {/* Action Buttons */}
    <div className="space-y-2 pt-2">
      <button
        onClick={(e) => handleAddToCart(e, product._id)}
        disabled={addingToCart}
        className={`w-full rounded-lg px-4 py-3 text-sm font-semibold text-white transition-colors ${
          addingToCart 
            ? "bg-gray-400 cursor-not-allowed" 
            : "bg-[#8B4513] hover:bg-[#654321]"
        }`}
      >
        {addingToCart ? "Adding..." : "Add to Cart"}
      </button>

      <button
        className={`w-full rounded-lg border px-4 py-3 text-sm font-medium transition-colors flex items-center justify-center gap-2 ${
          wishlistedItems.has(product._id)
            ? "bg-red-50 border-red-300 text-red-600 hover:bg-red-100"
            : "bg-white border-gray-300 text-gray-700 hover:bg-gray-50"
        }`}
        onClick={() => handleWishlistToggle(product._id)}
        disabled={loadingWishlist}
      >
        <svg 
          className={`w-4 h-4 ${wishlistedItems.has(product._id) ? "fill-current" : ""}`}
          fill={wishlistedItems.has(product._id) ? "currentColor" : "none"}
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
        </svg>
        {wishlistedItems.has(product._id) ? "Remove from Wishlist" : "Add to Wishlist"}
      </button>
    </div>

    {/* Description Section */}
    {product.description && product.description.length > 0 && (
      <div className="pt-4 border-t border-gray-200">
        <h2 className="text-base font-semibold text-gray-900 mb-3">Description</h2>
        <ul className="space-y-2">
          {product.description.map((desc, idx) => (
            <li key={idx} className="flex items-start gap-2 text-sm text-gray-700">
              <span className="text-[#8B4513] mt-1 flex-shrink-0">•</span>
              <span>{desc}</span>
            </li>
          ))}
        </ul>
      </div>
    )}

    {/* Material & Care Section */}
    {(product.materials?.length > 0 || product.careInstructions?.length > 0) && (
      <div className="border-t border-gray-200 pt-4">
        <details className="group">
          <summary className="cursor-pointer flex items-center justify-between py-2 text-sm font-medium text-gray-900 hover:text-[#8B4513]">
            <span>Material & Care</span>
            <svg 
              className="w-4 h-4 text-gray-500 transition-transform group-open:rotate-180" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </summary>
          <div className="pt-3 space-y-3">
            {product.materials?.length > 0 && (
              <div>
                <h4 className="text-xs font-semibold text-gray-700 mb-1">Materials:</h4>
                <ul className="space-y-1 text-sm text-gray-600">
                  {product.materials.map((mat, idx) => (
                    <li key={idx} className="flex items-start gap-2">
                      <span className="text-[#8B4513] mt-0.5">•</span>
                      <span>{mat}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {product.careInstructions?.length > 0 && (
              <div>
                <h4 className="text-xs font-semibold text-gray-700 mb-1">Care Instructions:</h4>
                <ul className="space-y-1 text-sm text-gray-600">
                  {product.careInstructions.map((care, idx) => (
                    <li key={`care-${idx}`} className="flex items-start gap-2">
                      <span className="text-[#8B4513] mt-0.5">•</span>
                      <span>{care}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </details>
      </div>
    )}
  </div>
</section>



        <section className="mt-12 py-6">
          <h3 className="mb-6 text-center text-lg font-semibold text-gray-900">You Might Also Like</h3>

          {loadingProducts ? (
  <div className="flex flex-col justify-center items-center py-20">
  <div className="sparkle-loader relative mb-4">
    <div className="golden-rings">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div className="sparkles">
      <div className="sparkle"></div>
      <div className="sparkle"></div>
      <div className="sparkle"></div>
      <div className="sparkle"></div>
    </div>
  </div>
  <p className="loader-text text-lg font-semibold text-yellow-400 animate-pulse">
    Loading products… ✨
  </p>
</div>

) : (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
    {allProducts.filter(p => p._id !== product._id).slice(0, 8).map((prod) => (
      <ProductCard
        key={prod._id}
        product={prod}
        isWishlisted={wishlistedItems.has(prod._id)}
        onWishlistToggle={handleWishlistToggle}
        onAddToCart={(id, size) => handleAddToCart(null, id, size)}
      />
    ))}
  </div>
)}

        </section>
      </main>

      <Sidebar isCartOpen={isCartOpen} onClose={closeCartSidebar} />
    </>
  )
}

export default ProductDetails
